import React from "react";
import { motion } from "framer-motion";
import {
  Assistant,
  CalendarMonth,
  DeveloperBoard,
  GridView,
  Groups,
  ViewTimeline,
} from "@mui/icons-material";

const ViewSelector = ({ viewMode, setViewMode }) => {
  // Material UI 3.0 inspired styling
  const styles = {
    container: {
      display: "inline-flex",
      backgroundColor: "#ffffff",
      borderRadius: "12px",
      position: "relative",
      overflow: "hidden",
      boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
    },
    button: {
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "10px 16px",
      minWidth: "100px",
      border: "none",
      background: "none",
      cursor: "pointer",
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontSize: "14px",
      zIndex: 1,
      transition: "all 0.2s ease",
    },
    activeButton: {
      color: "#1565C0",
      fontWeight: 500,
    },
    inactiveButton: {
      color: "rgba(0, 0, 0, 0.7)",
      fontWeight: 400,
    },
    icon: {
      marginRight: "8px",
    },
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      style={styles.container}
    >
      <motion.button
        style={{
          ...styles.button,
          ...(viewMode === "general"
            ? styles.activeButton
            : styles.inactiveButton),
        }}
        onClick={() => setViewMode("general")}
        whileTap={{ scale: 0.95 }}
      >
        <GridView size={18} style={styles.icon} />
        <span>Geral</span>
      </motion.button>

      <motion.button
        style={{
          ...styles.button,
          ...(viewMode === "thirty_days"
            ? styles.activeButton
            : styles.inactiveButton),
        }}
        onClick={() => setViewMode("thirty_days")}
        whileTap={{ scale: 0.95 }}
      >
        <CalendarMonth size={18} style={styles.icon} />
        <span>30 dias</span>
      </motion.button>

      <motion.button
        style={{
          ...styles.button,
          ...(viewMode === "orders_journey"
            ? styles.activeButton
            : styles.inactiveButton),
        }}
        onClick={() => setViewMode("orders_journey")}
        whileTap={{ scale: 0.95 }}
      >
        <ViewTimeline size={18} style={styles.icon} />
        <span>Jornada do Pedido</span>
      </motion.button>

      <motion.button
        style={{
          ...styles.button,
          ...(viewMode === "products_journey"
            ? styles.activeButton
            : styles.inactiveButton),
        }}
        onClick={() => setViewMode("products_journey")}
        whileTap={{ scale: 0.95 }}
      >
        <DeveloperBoard size={18} style={styles.icon} />
        <span>Jornada do Produto</span>
      </motion.button>

      <motion.button
        style={{
          ...styles.button,
          ...(viewMode === "delivery_data"
            ? styles.activeButton
            : styles.inactiveButton),
        }}
        onClick={() => setViewMode("delivery_data")}
        whileTap={{ scale: 0.95 }}
      >
        <Groups size={18} style={styles.icon} />
        <span>Entregas</span>
      </motion.button>

      {/*<motion.button*/}
      {/*  style={{*/}
      {/*    ...styles.button,*/}
      {/*    ...(viewMode === "catalog"*/}
      {/*      ? styles.activeButton*/}
      {/*      : styles.inactiveButton),*/}
      {/*  }}*/}
      {/*  onClick={() => setViewMode("catalog")}*/}
      {/*  whileTap={{ scale: 0.95 }}*/}
      {/*>*/}
      {/*  <Groups size={18} style={styles.icon} />*/}
      {/*  <span>Cardápio</span>*/}
      {/*</motion.button>*/}

      <motion.button
        style={{
          ...styles.button,
          ...(viewMode === "ai_analysis"
            ? styles.activeButton
            : styles.inactiveButton),
        }}
        onClick={() => setViewMode("ai_analysis")}
        whileTap={{ scale: 0.95 }}
      >
        <Assistant size={18} style={styles.icon} />
        <span>Análise IA</span>
      </motion.button>
    </motion.div>
  );
};

export default ViewSelector;
